import Vue from "vue";
import Vuex from "vuex";
import { base } from "../services/airtable";
import { firestoreDatabase } from "../services/firestore";
import { firestoreData } from "../utils/enums";
import dayjs from "dayjs";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    questions: [],
    coinsBalance: 0,
    startDate: null,
    endDate: null,
    startDateWeek: null,
    endDateWeek: null,
    playerName: "",
    playerEmail: "",
    alreadyPlay: false,
  },
  mutations: {
    setPlayerName(state, name) {
      state.playerName = name;
    },
    setPlayerEmail(state, email) {
      state.playerEmail = email;
    },
    setQuestions(state, questions) {
      state.questions = questions;
    },
    setAnswer(state, { id, answerSelected, answerStatus }) {
      const questionsUpdate = state.questions.map((question) => {
        if (question.id === id) {
          question.answerSelected = answerSelected;
          question.answerStatus = answerStatus;
        }
        return question;
      });
      state.questions = questionsUpdate;
    },
    setCoinBalance(state, coins) {
      state.coinsBalance = state.coinsBalance + coins;
    },
    setStartDate(state, date) {
      state.startDate = date;
    },
    setEndDate(state, date) {
      state.endDate = date;
    },
    setAlreadyPlay(state, play) {
      state.alreadyPlay = play;
    },
    setStartDateWeek(state, date) {
      state.startDateWeek = date;
    },
    setEndDateWeek(state, date) {
      state.endDateWeek = date;
    },
  },
  actions: {
    getQuestions({ commit, state }) {
      const startDateWeek = dayjs(state.startDateWeek).format("YYYY-MM-DD");
      const endDateWeek = dayjs(state.endDateWeek).format("YYYY-MM-DD");

      return base(process.env.VUE_APP_AIRTABLE_TABLE)
        .select({
          view: "Grid view",
          filterByFormula: `AND(IS_SAME({start_week}, "${startDateWeek}", 'day'),IS_SAME({end_week}, "${endDateWeek}", 'day'))`,
        })
        .eachPage(
          function page(records, fetchNextPage) {
            const questionsFields = records
              .map(function(record) {
                const fields = record.fields;
                if (
                  fields.id &&
                  fields.question &&
                  fields.correct_response &&
                  fields.feedback &&
                  fields.responses
                )
                  return {
                    id: fields.id,
                    sequenceNumber: null, //check
                    answerStatus: "NOT_ANSWERED",
                    question: fields.question,
                    answer: fields.correct_response,
                    feedback: fields.feedback,
                    options: fields.responses,
                    timeToAnswer: 20,
                    correctIndex: fields.responses
                      .map((option, index) => {
                        if (option === fields.correct_response) return index;
                      })
                      .filter((res) => res != null),
                    coins: 5,
                    startDate: fields.start_week,
                    endDate: fields.end_week,
                    answerSelected: null,
                  };
              })
              .filter(
                (question) =>
                  question && question.options.includes(question.answer)
              );
            commit("setQuestions", questionsFields);
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return err;
            }
          }
        );
    },
    answerQuestion({ commit }, payload) {
      commit("setAnswer", payload);
    },
    updateCoinsBalance({ commit }, { coins }) {
      commit("setCoinBalance", coins);
    },
    recordDateStart({ commit }) {
      commit("setStartDate", dayjs().format());
    },
    recordEndDate({ commit, state }) {
      commit("setEndDate", dayjs().format());

      const startDateWeek = dayjs(state.startDateWeek).format("YYYY-MM-DD");
      const endDateWeek = dayjs(state.endDateWeek).format("YYYY-MM-DD");

      const perfectScore = state.questions.every((item) => {
        return item.answerStatus === "CORRECT";
      });
      if (perfectScore) {
        commit("setCoinBalance", 3);
      }

      firestoreDatabase.collection(firestoreData.COLLECTION_NAME).add({
        playerName: state.playerName,
        playerEmail: state.playerEmail,
        coinsBalance: state.coinsBalance,
        questions: state.questions,
        startDate: state.startDate,
        endDate: state.endDate,
        sessionDataRange: {
          startDate: startDateWeek,
          endDate: endDateWeek,
        },
      });
    },
    setPlayerName({ commit }, payload) {
      commit("setPlayerName", payload);
    },
    setPlayerEmail({ commit }, payload) {
      commit("setPlayerEmail", payload);
    },
    loadQuestionsFromFirestore(
      { commit },
      { questions, playerEmail, playerName, coinsBalance, startDate, endDate }
    ) {
      commit("setQuestions", questions);
      commit("setPlayerEmail", playerEmail);
      commit("setPlayerName", playerName);
      commit("setCoinBalance", coinsBalance);
      commit("setStartDate", startDate);
      commit("setEndDate", endDate);
    },
    alreadyPlay({ commit }, payload) {
      commit("setAlreadyPlay", payload);
    },
    setStartDateWeek({ commit }, payload) {
      commit("setStartDateWeek", payload);
    },
    setEndDateWeek({ commit }, payload) {
      commit("setEndDateWeek", payload);
    },
    closeGame({ commit }, redirectRule) {
      if (window.nsWebViewBridge) {
        //score is the number of coins
        window.nsWebViewBridge.emit("close", redirectRule);
      } else {
        console.log("quit game");
      }
      commit;
    },
    sendScore({ state }) {
      if (window.nsWebViewBridge) {
        //score is the number of coins
        window.nsWebViewBridge.emit("gameFinished", state.coinsBalance);
      } else {
        console.log("game finished");
      }
    },
  },
});

export default store;
